export default {
      id: "oc-onecloud-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-onecloud",
      toString: function () {
        return this.url;
      }
    }